import React from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";

import {
  RiMapPin2Line,
  RiTimeLine,
  RiPhoneLine,
  RiStore2Line,
} from "react-icons/ri";

import "../../assets/css/modal.css";
import "../../assets/css/form.css"
import "../Sidebar/OutletInfo.css";
import { getOutlates } from "../../actions/productActions";
import ModalCloseButton from "../ModalCloseButton/ModalCloseButton";

import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

const formatTime = (time) => {
  let postfix; //AM, PM
  let timeArr; //Used to contain resulting array after split function
  let finalTime; //Used to combine the time array after 

  if (time > 12) { //Prepare for modulo operation, anything above 12, e.g 13, 14 will be counted as PM
    postfix = "PM"
  } else {
    postfix = "AM"
  }

  timeArr = (time % 12).toFixed(2).split(".") //toFixed parses the float into a string, Split for when time provided has decimal point
  if (timeArr.length > 1) {
    finalTime = timeArr[0] + ":" + timeArr[1] + " " + postfix
  } else {
    finalTime = timeArr[0] + ":" + "00" + " " + postfix
  }
  return finalTime
}

const shopOpenformatTime = (time) => {
  if (!time) return '';

  const [hourStr, minuteStr] = time.split(':');
  let hour = parseInt(hourStr, 10);
  const minute = parseInt(minuteStr, 10);

  const postfix = hour >= 12 ? 'PM' : 'AM';
  hour = hour % 12 || 12;

  return `${hour.toString().padStart(2, '0')}:${minute
    .toString()
    .padStart(2, '0')} ${postfix}`;
};
class Pickup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // outlates: props.outlatesx,
      select: false,
      activeItem: -1,
      noOutlets: 0
    };
    this.outlateRenders = this.outlateRenders.bind(this);
  }
  componentDidMount() {
    this.props.getOutlates();
  }

  selctOutlate = (e, id, name, index, amount_rounding_method) => {
    let oldorder = this.props.order;
    oldorder["out_id"] = id;
    oldorder["out_name"] = name;
    this.props.setOrder(oldorder);
    this.setState({ activeItem: index });
    localStorage.setItem("outlate", id);
    localStorage.setItem("out_name", name);
    this.props.setAmountRoundingMethod(amount_rounding_method);
  };

  outlateRenders = () => {
    let html = [];
    let cdata = this.props.outlates?.business_location;
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var today = new Date();
    var todayDay = days[today.getDay()];

    const checkIfRestDay = (outlet) => { //RETURN FALSE IF REST DAY IS NULL, RETURN ACCORDINGLY(BASED ON TODAY'S DAY) IF ITS NOT
      // if (outlet?.custom_field2) {
      if (
        outlet?.custom_field2 &&
        (
          (typeof outlet.custom_field2 === "string" &&
            JSON.parse(outlet.custom_field2 || "[]").length > 0) ||
          (Array.isArray(outlet.custom_field2) &&
            outlet.custom_field2.length > 0)
        )
      ) {
        let outletRestDay = outlet.custom_field2
        const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"]
        const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
        const userDate = new Date((new Date).toLocaleString('en-US', { timeZone: userTimeZone }))
        if (outletRestDay[0] === days[userDate.getDay() - 1]) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }

    if (cdata != null && Object.keys(cdata).length > 0) { //CHECK IF cdata IS DEFINED AND IF THERE ARE PROPERTIES
      Object.keys(cdata).map((key, index) => {
        if (cdata[index]?.custom_field3) {
          this.noOutlets++;
          var isRestDay = cdata[index]?.custom_field2?.includes(todayDay);
          let opening_time = [] //MANUALLY FORMAT THE TIME FROM CUSTOM_FIELD3 
          for (let i = 0; i < cdata[index]?.custom_field3.length; ++i) {
            opening_time.push(cdata[index].custom_field3[i])
          }

          const shopOpenTime = `${shopOpenformatTime(cdata[index].open_time)} - ${shopOpenformatTime(cdata[index].close_time)}`;
          // CHANGE OPENING_TIME FORMAT TO E.G [ '10PM - 3PM', '5PM - 12AM' ]
          opening_time = opening_time.map((time) => (`${formatTime(time[0])} - ${formatTime(time[1])}`))

          if (opening_time.length > 1) { //CHECK IF ARRAY IS MORE THAN 1 ELEMENT E.G [ '10PM - 3PM', '5PM - 12AM' ]
            let merged_time = opening_time[0] //START FROM FIRST ELEMENT E.G '10PM - 3PM' AND APPEND THE COMMAS AND TIME FROM THERE
            for (let i = 1; i < opening_time.length; ++i) { //FOR LOOP THAT IS APPENDING THE TIME ELEMENTS
              merged_time += ", " + opening_time[i]
            }
            opening_time[0] = merged_time //SET THE FIRST ELEMENT TO THE MERGED TIME E.g '10PM - 3PM, 5PM - 12AM' SO LATER JUST TO OPENING_TIME[0]
          }

          html.push(
            <div
              style={
                !cdata[index].is_open || checkIfRestDay(cdata[index])
                  ? {
                    pointerEvents: "none",
                    cursor: "not-allowed",
                    opacity: "0.4",
                  }
                  : {
                    pointerEvents: "auto",
                    cursor: "pointer",
                    opacity: "1",
                  }
              }
              key={key}
              className={`outlet-item-card ${this.state.activeItem === cdata[index]?.id ? "selected" : ""
                }`}
              onClick={(e) => {
                this.props.setPaymentMethod(null)
                this.props.setPaynowNumber(cdata[key].paynow_number)
                this.props.setAmountRoundingMethod(cdata[key].amount_rounding_method)
                localStorage.setItem("paynow_number", cdata[key].paynow_number)
                localStorage.setItem("amount_rounding_method", cdata[key].amount_rounding_method)
                this.selctOutlate(e, cdata[key].id, cdata[key].name, index, cdata[key].amount_rounding_method)
              }

              }
            >
              <div className="outlet-card-header">
                <span className="outlet-name">{cdata[key].name}</span>
                <span
                  className={`status-badge ${cdata[key].is_open && !isRestDay ? "open" : "closed"
                    }`}
                >
                  {cdata[key].is_open && !isRestDay ? "Open" : "Closed"}
                </span>
              </div>

              <div className="outlet-body">
                <div className="outlet-info-row">
                  <RiMapPin2Line />
                  <span>{cdata[key].address}</span>
                </div>
                <div className="outlet-info-row">
                  <RiTimeLine />
                  <span>{shopOpenTime}</span>
                </div>
                <div className="outlet-info-row highlight">
                  <RiPhoneLine />
                  <span>{cdata[key].phone}</span>
                </div>
              </div>
            </div>
          );
        }
      });
    }
    return html;
  };

  static getDerivedStateFromProps(props, state) {
    if (localStorage.outlate) {
      if (props.outlates) {
        let outlates = props.outlates.business_location
        for (let i = 0; i < outlates.length; ++i) {
          let today = new Date();
          let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
          let todayDay = days[today.getDay()];
          if (outlates[i].id === parseInt(localStorage.outlate)) {
            if (outlates[i].is_open && !(outlates[i]?.custom_field2?.includes(todayDay))) {
              return { ...state, activeItem: parseInt(localStorage.outlate) }
            } else {
              localStorage.removeItem("outlate")
              localStorage.removeItem("out_name")
              localStorage.removeItem("")
              return { ...state }
            }
          }
        }
      }
    }
    return null;
  }

  render() {
    let cdata = this.props.outlates?.business_location;
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var today = new Date();
    var todayDay = days[today.getDay()];
    var availableOutlets = 0;

    if (cdata && Object.keys(cdata).length > 0) {
      Object.keys(cdata).forEach((key, index) => {
        if (cdata[index]?.custom_field3) {
          var isRestDay = cdata[index]?.custom_field2?.includes(todayDay);
        }
        if (cdata[key].is_open && !isRestDay && cdata[index]?.custom_field3 !== null) {
          availableOutlets += 1;
        }
      })
    }
    return (
      <Modal
        show={this.props.show}
        onHide={this.props.closeModal}
        className="premium-modal outlet-modal"
        dialogClassName="modal-md"
        centered
        backdrop="static"
      >
        <Modal.Header>
          <h4 className="modal-title">Select Pickup Outlet</h4>
          <ModalCloseButton
            onClick={this.props.closeModal}
            style={{ position: "static", width: "32px", height: "32px" }}
          />
        </Modal.Header>
        <Modal.Body>
          <div className="availability-header">
            <RiStore2Line />
            <span>
              {availableOutlets > 0
                ? `${availableOutlets} Store(s) Available`
                : "No Store available."}
            </span>
          </div>
          <div className="outlet-list">{this.outlateRenders()}</div>
        </Modal.Body>

        <Modal.Footer className="border-0">
          <button
            type="submit"
            disabled={this.state.activeItem === -1}
            className="btn lg primary d-block w-100"
            style={
              this.state.activeItem === -1
                ? { pointerEvents: "none", opacity: 0.5 }
                : {}
            }
            onClick={this.props.showPickupDate}
          >
            Select Outlet
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

Pickup.propTypes = {
  closeModal: PropTypes.func.isRequired,
  showPickupDate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  outlates: state.products.outlates,
  loading: state.products.loading,
});
export default withTranslation()(
  connect(mapStateToProps, { getOutlates })(Pickup)
);
